// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__jSop_","title":"style_title__Gp6LD","desc":"style_desc__jSvaT","image":"style_image__V5Lhu"};